import React, {useEffect, useState} from "react";
import uaeAccounts, { uaeAccountsAndBalances } from "../data/uae/accounts";
import ksaAccounts, { ksaAccountsAndBalances } from "../data/ksa/accounts";
import uaeBalances from "../data/uae/balances";
import ksaBalances from "../data/ksa/balances";
import Code from "../components/Code";
import styled from "styled-components";

const Container = styled.div`
  background-color: #fcfcfc;
  padding: 0 24px 24px 24px;
  max-width: 1152px;
  margin: auto;
  background-color: #fcfcfc;
  height: 100%;

  p {
    margin: 0;
  }

  h2 {
    margin: 0;
    padding: 16px 0;
    font-size: 16px;
    font-weight: 600;
  }
`;

const Block = styled.div`
  text-transform: capitalize;
  border-bottom: 0.5px solid #e4e7e7;
  padding: 16px 0;
  font-size: 14px;
  color: #959d9d;
  font-weight: 400;

  div {
    display: flex;
    justify-content: space-between;
    margin: 0;
  }
`;
const T = styled.p`
  color: #081717;
`;
const V = styled(T)`
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier,
    monospace;
`;

const Accounts = ({country}) => {
  const [accounts, setAccounts] = useState([])
  const [accountsAndBalances, setAccountsAndBalances] = useState({})
  const [balances, setBalances] = useState([])

  useEffect(() => {
    if (country !== "SAU") {
      setAccounts(uaeAccounts)
      setAccountsAndBalances(uaeAccountsAndBalances)
      setBalances(uaeBalances)
    } else {
      setAccounts(ksaAccounts)
      setAccountsAndBalances(ksaAccountsAndBalances)
      setBalances(ksaBalances)
    }
  }, [])
  return (
    <>
      <Container>
        <h2>Accounts</h2>
        {accounts.map((account) => {
          const balance = balances.find(
            (x) => x.account_id === account.account_id
          );
          return (
            <Block key={account.account_id}>
              <div>
                <T>{account.name}</T>
                <V>{balance.balance.toLocaleString()}</V>
              </div>
              <div>
                <p>
                  {account.bank_identifier.split("_")[0]} -{" "}
                  {account.type.toLowerCase()}
                </p>
                <p>{account.currency_code}</p>
              </div>
              <div>
                <p>
                  {account.iban
                    ? account.iban
                    : `card ending ${account.credit.card_number_last_four}`}
                </p>
              </div>
            </Block>
          );
        })}
      </Container>
      <Code code={accountsAndBalances} />
    </>
  );
};

export default Accounts;
